<template>
  <div v-if="load">

    <div class="row mt-4 mb-3">
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
    </div>

  </div>

  <div v-else>
    <table class="table table-borderless table-border table-align table-h51">
      <thead>
      <tr>
        <th>Nome</th>
        <th>Email</th>
        <th>Grupo de permissão</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="user in users" :key="user.id">
        <td>{{ user.name }}</td>
        <td>{{ user.email }}</td>
        <td>
          <span v-if="!groupsOf(user).length" class="text-muted">—</span>
          <span v-for="group in groupsOf(user)" :key="group.id"
                class="badge mr-1" :class="group.systemKey ? 'badge-secondary' : 'badge-light'">
            {{ group.name }}
          </span>
        </td>
        <td class="text-right">

          <template v-if="$withPolicy('application', 'users') || user.id === getUser.id">
            <button @click="$emit('showUser', user)" class="btn-icon btn-outline mr-2">
              <edit-icon size="1.5x"/>
            </button>
          </template>

          <template v-if="$withPolicy()">
            <button v-if="user.id !== getUser.id" @click="$emit('sendDeleteUser', user)" class="btn-icon btn-outline-red mr-2">
              <trash-2-icon size="1.5x"/>
            </button>
          </template>

        </td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
  import { Trash2Icon, EditIcon } from 'vue-feather-icons'
  import GetUser from '@/mixins/GetUser'

  export default {
    components: { EditIcon, Trash2Icon },
    data() {
      return {
        load: false
      }
    },
    methods: {
      groupsOf(user) {
        return user.permissionGroups || []
      }
    },
    mixins: [GetUser],
    name: 'Table',
    props: {
      users: { required: true, type: Array }
    }
  }
</script>

<style scoped>

.skeleton {
  background: linear-gradient(to right, #eee 2%, #ddd 18%, #eee 33%);
  background-size: 1300px;
  animation: gradient 1.7s ease infinite;
  border-radius: 3px;
  height: 30px;
  animation-duration: 1.7s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: gradient;

}

@keyframes gradient {
  0% {
    background-position: -650px 0;
  }
  100% {
    background-position: 650px 0;
  }
}

</style>
